export const GET_CONTACTBLOCK_BY_ID_M = (id, preview: boolean) => `
  query {
    contactBlock(id: "${id}", preview: ${preview}) {
      sys {
        id
      }
      personalName
      email
      emailTitleTag
      phone
      phoneLabel
      phoneTitleTag
      phoneTwo
      phoneTwoLabel
      phoneTwoTitleTag
      address
      addressType
      addressLink
      box
      zipCode
      faxLabel
      fax
      faxTitleTag
      state
      ivImage
      jobTitel
      extraInfo
      biography {
        json
      }
      audienceCollection {
        items {
          __typename
          sys {
            id
          }
          audianceId
        }
      }
      linkText
      linkVariant
      externalLink
      internalLink {
        slug
        content {
          __typename
        }
      }
    }
  }
`;
